import { useQuery } from '@tanstack/react-query'

// 시/도·시/군/구 목록은 quebon-api-java 의 공개 API 한 곳에서 받는다 (원본: 국토교통부 법정동코드).
// 시/군/구 이름에는 시/도명이 붙지 않는다 (예: '강남구', '수원시 장안구').
const REGIONS_API = 'https://api.quebon.tv/common/v1/regions'

export interface RegcodeEntry {
  code: string
  name: string
}

interface RegionEntry extends RegcodeEntry {
  sigungu: RegcodeEntry[]
}

const FALLBACK_REGIONS: readonly RegionEntry[] = [
  { code: '1100000000', name: '서울특별시', sigungu: [] },
  { code: '2600000000', name: '부산광역시', sigungu: [] },
  { code: '2700000000', name: '대구광역시', sigungu: [] },
  { code: '2800000000', name: '인천광역시', sigungu: [] },
  { code: '3000000000', name: '대전광역시', sigungu: [] },
  { code: '3100000000', name: '울산광역시', sigungu: [] },
  { code: '3600000000', name: '세종특별자치시', sigungu: [] },
  { code: '4100000000', name: '경기도', sigungu: [] },
  { code: '5100000000', name: '강원특별자치도', sigungu: [] },
  { code: '4300000000', name: '충청북도', sigungu: [] },
  { code: '4400000000', name: '충청남도', sigungu: [] },
  { code: '5200000000', name: '전북특별자치도', sigungu: [] },
  { code: '1200000000', name: '전남광주통합특별시', sigungu: [] },
  { code: '4700000000', name: '경상북도', sigungu: [] },
  { code: '4800000000', name: '경상남도', sigungu: [] },
  { code: '5000000000', name: '제주특별자치도', sigungu: [] },
]

async function fetchRegions(): Promise<RegionEntry[]> {
  const res = await fetch(REGIONS_API)
  if (!res.ok) throw new Error(`regions fetch failed: ${res.status}`)
  return (await res.json()) as RegionEntry[]
}

export function useSidoList() {
  return useQuery({
    queryKey: ['regions'],
    queryFn: fetchRegions,
    staleTime: Infinity,
    placeholderData: FALLBACK_REGIONS as RegionEntry[],
    retry: 1,
    select: (regions): RegcodeEntry[] =>
      regions.map(({ code, name }) => ({ code, name })),
  })
}

export function useSigunguList(sidoCode: string | undefined) {
  return useQuery({
    queryKey: ['regions'],
    queryFn: fetchRegions,
    enabled: !!sidoCode,
    staleTime: Infinity,
    retry: 1,
    select: (regions): RegcodeEntry[] =>
      regions.find((it) => it.code === sidoCode)?.sigungu ?? [],
  })
}
